<template>
  <div class="lodging-rooms-show">
    <p class="merriweather-light-20" v-if="entireLodging">{{ lodging.lodging_description && lodging.lodging_description.rooms_description && lodging.lodging_description.rooms_description != 'null' && lodging.lodging_description.rooms_description != 'undefined' ? lodging.lodging_description.rooms_description : 'Les chambres' }}</p>
    <div
      v-for="room in displayedRooms"
      :key="room.id"
      class="lodging-room-item"
      :class="isPhone ? 'mb-3' : 'mb-5'"
    >
      <portal to="modals">
        <ModalRoomGalery v-if="showRoomGalery && !entireLodging" :key="`modal-room-${room.id}`" :item="room" @close="showModalRoomGalery()" />
        <RoomGalleryModal
          v-if="showRoomGalery && entireLodging"
          :item="lodging"
          @close="showModalRoomGalery()"
        />
      </portal> 
      <div class="row">
        <div class="col-lg-4 col-md-12 lodging-room-photo">
          <div class="room-image-container">
            <div class="swiper-container room-image-slider" :class="`room-slider-${room.id}`">
              <div class="swiper-wrapper">
                <div
                  v-for="(photo, index) in getRoomPhotos(room)"
                  :key="`room_${room.id}_${index}`"
                  class="swiper-slide"
                  :style="index < 2 ? { backgroundImage: `url('${photo}')` } : {}"
                  :data-src="photo"
                >
                </div>
              </div>
              <div class="swiper-button-next" @click.stop></div>
              <div class="swiper-button-prev" @click.stop></div>
              <div class="swiper-pagination"></div>
            </div>
          </div>
        </div>
        <div class="col-lg-5 col-md-12 lodging-room-info">
          <div class="d-flex justify-content-between align-items-center">
            <div class="d-flex align-items-baseline" :class="isPhone ? 'mt-3' : ''">
              <h3 class="raleway-semi-p15 mb-0 text-uppercase">{{ room.name }}</h3>
              <div class="d-flex align-items-center ml-2">
                <p class="raleway-medi-p15 mb-0">{{ room.capacity }}</p>
                <img
                  src="../../images/profil.svg"
                  v-set-alt
                  style="width: 14px; height: 11px;"
                />
              </div>
            </div>
            <span
              class="raleway-semi-p13 text-uppercase text-underline cursor-pointer text-nowrap ml-1 mt-2"
              style="color: #2C5E4B;"
              @click="openRoomModal(room)"
              v-if="isPhone"
            >
              VOIR LA CHAMBRE
            </span>
          </div>
          <span 
            v-if="accommodation_code && getRoomStockLeft(room) > 0 && getRoomStockLeft(room) < 5 && getRoomAvailabilityStatus(room.id) !== 'unavailable'" 
            class="raleway-reg-p12 stock-left-badge"
          >
            PLUS QUE {{ getRoomStockLeft(room) }} CHAMBRE{{ getRoomStockLeft(room) > 1 ? 'S' : '' }} DISPONIBLE{{ getRoomStockLeft(room) > 1 ? 'S' : '' }}
          </span>
          <div class="room-details raleway-reg-p15" :class="isPhone ? '' : 'mt-3'">
            <p v-if="room.number_of_rooms">
              {{ room.number_of_rooms }} {{ room.number_of_rooms === 1 ? 'chambre' : 'chambres' }}
            </p>
            <p v-if="room.bed_type">{{ room.bed_type }}</p>
            <p v-if="room.area">Superficie {{ room.area }}m²</p>
            <p v-if="room.extra_bed">{{ room.extra_bed }}</p>
            <p v-if="room.view_on">{{ room.view_on }}</p>
            <p>Capacité {{ room.capacity }} personnes</p>
          </div>
          <span
            class="mt-3 raleway-semi-p15 text-uppercase text-underline cursor-pointer"
            style="color: #2C5E4B;"
            @click="openRoomModal(room)"
            v-if="!isPhone"
          >
            VOIR LES DÉTAILS DE LA CHAMBRE
          </span>
        </div>
         <div class="col-lg-3 col-md-12 d-flex" :class="isPhone && getRoomLowestPrice(room) ? 'justify-content-between mt-1' : 'flex-column justify-content-center align-items-end'" v-if="!entireLodging">
           <div class="d-flex flex-column" :class="isPhone ? 'align-items-start w-100' : 'align-items-end'" v-if="getRoomLowestPrice(room)">
              <div class="d-flex" :class="isPhone ? '' : 'flex-column align-items-end'">
                <p class="raleway-reg-p15 mb-0">À partir de</p>
                <p class="raleway-semi-p15 mb-0" :class="isPhone ? 'ml-1' : ''">{{ getRoomLowestPrice(room) }} EUR <span class="raleway-reg-p13 mb-0">par nuit</span></p>
              </div>
           </div>
          <div class="d-flex flex-column align-items-end" :class="isPhone ? '' : 'w-100'">
            <button
              v-if="showVoirLesTarifsForDatePicker()"
              class="raleway-semi-p15 text-uppercase text-nowrap hortense-btn-primary"
              :class="[
                room.lowest_price ? 'mt-2' : '',
                isPhone ? 'mt-2' : 'w-100'
              ]"
              @click="$emit('open-date-picker')"
            >
              VOIR LES TARIFS
            </button>
            <button
              v-else
              class="raleway-semi-p15 text-uppercase text-nowrap"
              :class="[
                room.lowest_price ? 'mt-2' : '',
                isPhone ? 'mt-2' : 'w-100',
                ['unavailable', 'search'].includes(getRoomAvailabilityStatus(room.id)) ? 'hortense-btn-disabled' : 'hortense-btn-primary',
                showTariffs[room.id] && !['unavailable', 'search'].includes(getRoomAvailabilityStatus(room.id)) ? 'hortense-btn-primary-active' : ''
              ]"
              :disabled="['unavailable', 'search'].includes(getRoomAvailabilityStatus(room.id))"
              @click="toggleRoomTariffs(room.id)"
            >
              {{ getRoomButtonText(room.id) }}
              <i v-if="!['unavailable', 'search'].includes(getRoomAvailabilityStatus(room.id))" class="fa ml-2" :class="showTariffs[room.id] ? 'fa-angle-up' : 'fa-angle-down'" style="width: 7px; height: 14px;" aria-hidden="true"></i>
            </button>
            <span v-if="getRoomAvailabilityStatus(room.id) === 'unavailable' && minNightsNew[room.id] && nights !== undefined && nights !== null && nights < minNightsNew[room.id]" class="raleway-reg-p11 mt-2 d-flex align-items-baseline" style="gap:4px;" :class="isPhone ? 'mb-2' : ''">
              <i class="fas fa-info-circle"></i>
              <div class="d-flex">Nombre de nuits minimum <span class="raleway-semi-p11 ml-1">{{ minNightsNew[room.id] }}</span></div>
            </span>
          </div>
        </div>
      </div>

      <div
        v-if="showTariffs[room.id] && showKoediaPackagePicker"
        class="koedia-room-combinations mt-4"
      >
        <div class="d-flex flex-column flex-md-row justify-content-between align-items-md-end" style="gap: 8px;">
          <div>
            <p class="raleway-semi-p15 mb-1 text-uppercase">Combinaisons avec cette chambre</p>
            <p class="raleway-reg-p13 mb-0">
              Choisissez l'une des configurations disponibles pour l'ensemble de votre séjour.
            </p>
          </div>
          <p class="raleway-reg-p13 mb-0" v-if="getKoediaPackagesForRoom(room).length > 0">
            {{ getKoediaPackagesForRoom(room).length }} option{{ getKoediaPackagesForRoom(room).length > 1 ? 's' : '' }}
          </p>
        </div>

        <div class="koedia-package-grid mt-3" v-if="getKoediaPackagesForRoom(room).length > 0">
          <button
            v-for="(pkg, packageIndex) in getKoediaPackagesForRoom(room)"
            :key="pkg.key"
            type="button"
            class="koedia-package-card text-left"
            :class="{ selected: selectedKoediaPackageKey === pkg.key }"
            @click="selectKoediaPackage(pkg)"
          >
            <div class="d-flex justify-content-between align-items-start mb-3" style="gap: 12px;">
              <p class="raleway-semi-p15 mb-0 text-uppercase">Option {{ packageIndex + 1 }}</p>
              <div class="text-right">
                <p class="raleway-semi-p15 mb-0">{{ pkg.totalPrice.toFixed(2) }} EUR</p>
                <p class="raleway-reg-p13 mb-0">total séjour</p>
              </div>
            </div>

            <div class="koedia-package-rooms">
              <div
                v-for="line in pkg.roomLines"
                :key="line.room.id"
                class="koedia-package-room-line d-flex justify-content-between align-items-start"
                style="gap: 12px;"
              >
                <div>
                  <p class="raleway-semi-p13 mb-0">
                    {{ line.qty }} × {{ line.roomName }}
                  </p>
                  <p class="raleway-reg-p13 mb-0" v-if="line.boardSummary">{{ line.boardSummary }}</p>
                </div>
                <p class="raleway-semi-p13 mb-0 text-nowrap">{{ line.totalPrice.toFixed(2) }} EUR</p>
              </div>
            </div>

            <div class="koedia-package-meta mt-3">
              <span>{{ pkg.refundable ? 'Annulation selon tarif' : 'Non remboursable' }}</span>
              <span>{{ pkg.roomCount }} chambre{{ pkg.roomCount > 1 ? 's' : '' }}</span>
              <span v-if="selectedKoediaPackageKey === pkg.key">Sélectionnée</span>
            </div>
          </button>
        </div>

        <p v-else class="raleway-reg-p13 mb-0 mt-3">
          Aucune combinaison complète ne contient cette chambre pour la configuration voyageurs choisie.
        </p>
      </div>
      
      <!-- ReservationCard Display -->
      <div v-if="showTariffs[room.id] && !showKoediaPackagePicker && roomAvailabilities[room.id] && (!accommodation_code || koediaSessionId)" class="row mt-4">
        <div class="col-12">
          <ReservationCard
            :minNights="minNights"
            :minNightsNew="minNightsNew[room.id]"
            :lodging="lodging"
            :searched="searched"
            :isSearching="isSearching"
            :item="room"
            :key="room.id"
            :from="from"
            :to="to"
            :roomAvailability="roomAvailabilityForRoom(room)"
            :roomAvailabilityNotKoedia="roomAvailabilityNotKoedia(room.id)"
            :tariffsNotKoedia="tariffsNotKoedia(room.id)"
            :accomodationCode="accommodation_code"
            :numberOfRoom="numberOfRoom"
            :taxNotKoedia="tax"
            :koediaSessionId="koediaSessionId"
            :nights="nights"
            :koediaFrom="koediaFrom"
            :koediaTo="koediaTo"
            :adults="adults"
            :childAges="childAges"
            :tariffQtys="getRoomTariffQtys(room.id)"
            :maxRoomQty="getRoomMaxQty(room)"
            :selectMultipleRooms="selectMultipleRooms"
            :roomInventories="roomInventories"
            @sendInfo="displayUserInfo"
            @open-guest-modal="openGuestModal"
            @incrementTariff="(data) => incrementTariff(room.id, data)"
            @decrementTariff="(data) => decrementTariff(room.id, data.tariff)"
          />
        </div>
      </div>
    </div>
    
    <!-- Sticky Bottom Bar for Multi-Room Booking -->
    <div v-if="selectMultipleRooms && Object.values(cartItems).some(item => item.qty > 0)" class="sticky-reserve-bar">
      <div class="bar-content d-flex justify-content-between" :class="isPhone ? 'align-items-start' : 'align-items-center'">
        <div class="bar-info">
          <p class="mb-0" :class="isPhone ? 'raleway-semi-p13' : 'raleway-semi-p15'">
            <span class="rooms-count">{{ Object.values(cartItems).reduce((sum, item) => sum + item.qty, 0) }}</span>
            chambre{{ Object.values(cartItems).reduce((sum, item) => sum + item.qty, 0) > 1 ? 's' : '' }} sélectionnée{{ Object.values(cartItems).reduce((sum, item) => sum + item.qty, 0) > 1 ? 's' : '' }}
          </p>
          <p class="mb-0" :class="isPhone ? 'raleway-semi-p13' : 'raleway-semi-p18'" style="color: #2C5E4B;">
            {{ cartTotal.toFixed(2) }} EUR
          </p>
        </div>
        <button
          class="hortense-btn-primary"
          :class="isPhone ? 'w-auto mt-0' : ''"
          @click="reserveAll()"
          :disabled="isReserveValidating"
          style="padding: 12px 32px;"
        >
          {{ isReserveValidating ? 'VÉRIFICATION...' : 'RÉSERVER' }}
        </button>
      </div>
      <p v-if="reserveErrorMessage" class="raleway-reg-p12 mb-0 mt-2 text-center w-100" style="color: #D56A70;">
        {{ reserveErrorMessage }}
      </p>
    </div>
    
    <!-- Show More/Less Button for Entire Lodging -->
    <div v-if="entireLodging && rooms.length > 2" class="mt-4 mb-4">
      <span
        class="raleway-semi-p15 text-uppercase text-underline cursor-pointer"
        style="color: #2C5E4B;"
        @click="toggleShowAllRooms"
      >
        {{ showAllRooms ? 'VOIR MOINS' : 'VOIR PLUS' }}
      </span>
    </div>
    
    <!-- Room Details Modal -->
    <RoomDetailsModal
      v-if="showRoomModal"
      :room="selectedRoom"
      @close="closeRoomModal"
      @show-room-galery="showModalRoomGalery"
    />
    <hr v-if="!isPhone" />
  </div>
</template>
<script>
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/swiper.min.css';
import 'swiper/modules/navigation.min.css';
import 'swiper/modules/pagination.min.css';
import RoomDetailsModal from '../../components/modals/RoomDetailsModal.vue';
import ModalRoomGalery from "../../components/modals/ModalRoomGalery.vue";
import ReservationCard from "../../components/cards/ReservationCard";
import fetcher from "packs/shared/api.js";
import RoomGalleryModal from "../../components/modals/RoomGalleryModal.vue";
import roomStockMixin from "../../mixins/roomStockMixin";
import { ensureOspitaTrackingId, normalizeRoomPlans, resolveReservationEventName } from "../../utils/reservationFlow";

Swiper.use([Navigation, Pagination]);

export default {
  name: "LodgingshowRooms",
  mixins: [roomStockMixin],
  components: {
    RoomDetailsModal,
    ModalRoomGalery,
    ReservationCard,
    RoomGalleryModal
  },
  props: {
    lodging: {
      type: Object,
      required: true,
    },
    rooms: {
      type: Array,
      required: true,
    },
    entireLodging: {
      type: Boolean,
      required: false,
      default: false,
    },
    adults: {
      type: Number,
      required: false,
      default: 2,
    },
    selectMultipleRooms: {
      type: Boolean,
      required: false,
      default: false,
    },
    initialChildAges: {
      type: Array,
      required: false,
      default: () => ([]),
    },
    roomPlans: {
      type: Array,
      required: false,
      default: () => ([]),
    },
  },
  data() {
    return {
      swiperInstances: {},
      showRoomModal: false,
      selectedRoom: null,
      isPhone: window.innerWidth <= 768,
      showRoomGalery: false,
      showAllRooms: false,
      // Availability data
      showTariffs: {},
      roomAvailabilities: {},
      availabilitiesNotKoedia: {},
      availabilities: null,
      koediaSessionId: null,
      koediaFrom: null,
      koediaTo: null,
      from: null,
      to: null,
      searched: false,
      isSearching: false,
      minNights: Number,
      minNightsNew: {},
      numberOfRoom: 0,
      childs: 0,
      childAges: Array.isArray(this.initialChildAges) ? [...this.initialChildAges] : [],
      nights: 0,
      koediaAvailabilityCache: null,
      koediaCacheKey: null,
      koediaLoading: false,
      accommodation_code: this.lodging.lodging_channel_manager ? this.lodging.lodging_channel_manager.accommodation_code : null,
      tax: this.lodging.tax,
      // Inventory data for Koedia
      roomInventories: {},
      inventoriesLoading: false,
      inventoriesCacheKey: null,
      // Multi-room booking cart
      cartItems: {}, // { roomId_tariff: { room, tariff, qty, priceData } }
      cartTotal: 0,
      isReserveValidating: false,
      reserveErrorMessage: '',
      previousSearchKey: null,
      selectedKoediaPackageKey: null,
    };
  },
  computed: {
    displayedRooms() {
      const sortedRooms = [...(this.rooms || [])].sort(
        this.entireLodging ? this.naturalSort : this.sortByPrice
      );

      if (this.entireLodging && !this.showAllRooms && sortedRooms.length > 2) {
        return sortedRooms.slice(0, 2);
      }

      return sortedRooms;
     },
    showKoediaPackagePicker() {
      return !!(this.accommodation_code && this.selectMultipleRooms && !this.entireLodging);
    },
    koediaPossibilityPackages() {
      if (!this.showKoediaPackagePicker || !this.availabilities) return [];

      const roomPlans = this.resolvedRoomPlans();
      const expectedRoomCount = roomPlans.length > 0 ? roomPlans.length : 1;
      const grouped = {};

      Object.values(this.availabilities).forEach((availability) => {
        const options = Array.isArray(availability?.options) ? availability.options : [];
        options.forEach((option) => {
          const key = option?.possibility_key;
          if (!key) return;

          if (!grouped[key]) grouped[key] = [];
          grouped[key].push(option);
        });
      });

      return Object.entries(grouped)
        .map(([key, options]) => {
          const mappedOptions = options
            .map((option) => {
              const room = this.resolveRoomForKoediaOption(option);
              if (!room) return null;

              return {
                room,
                option,
                roomName: room.name || option.room_name || 'Chambre',
              };
            })
            .filter(Boolean);

          const uniqueRooms = [...new Map(mappedOptions.map((entry) => [entry.option.room_id, entry])).values()];
          if (uniqueRooms.length !== expectedRoomCount) return null;

          const possibilityRoomIds = Array.isArray(options[0]?.possibility_room_ids)
            ? options[0].possibility_room_ids.map((roomId) => String(roomId))
            : [];
          const orderedRooms = possibilityRoomIds.length > 0
            ? [...uniqueRooms].sort((a, b) => {
              const indexA = possibilityRoomIds.indexOf(String(a.option.room_id));
              const indexB = possibilityRoomIds.indexOf(String(b.option.room_id));
              return (indexA < 0 ? Number.MAX_SAFE_INTEGER : indexA) - (indexB < 0 ? Number.MAX_SAFE_INTEGER : indexB);
            })
            : uniqueRooms;

          const roomLines = [...orderedRooms.reduce((lines, entry) => {
            const roomKey = entry.room.id;
            const currentLine = lines.get(roomKey) || {
              room: entry.room,
              roomName: entry.roomName,
              qty: 0,
              totalPrice: 0,
              boardLabels: [],
            };
            const boardLabel = this.getKoediaBoardLabel(entry.option);

            currentLine.qty += 1;
            currentLine.totalPrice += Number(entry.option?.room_price?.total?.rack) || 0;
            if (boardLabel && !currentLine.boardLabels.includes(boardLabel)) {
              currentLine.boardLabels.push(boardLabel);
            }
            lines.set(roomKey, currentLine);
            return lines;
          }, new Map()).values()].map((line) => ({
            ...line,
            boardSummary: line.boardLabels.join(' • '),
          }));
          const totalPrice = Number(options[0]?.possibility_total_price?.rack);
          const fallbackTotal = orderedRooms.reduce((sum, entry) => sum + (Number(entry.option?.room_price?.total?.rack) || 0), 0);

          return {
            key,
            options: orderedRooms,
            roomCount: orderedRooms.length,
            roomLines,
            refundable: orderedRooms.every((entry) => !!entry.option?.refundable),
            totalPrice: Number.isFinite(totalPrice) && totalPrice > 0 ? totalPrice : fallbackTotal,
            roomIds: roomLines.map((line) => line.room.id),
          };
        })
        .filter(Boolean)
        .sort((a, b) => a.totalPrice - b.totalPrice);
    },
   },
   watch: {
     selectMultipleRooms(newValue, oldValue) {
       if (newValue !== oldValue) {
         this.clearCart();
         this.selectedKoediaPackageKey = null;
       }
     },
     roomPlans: {
       handler() {
         this.clearCart();
          this.koediaAvailabilityCache = null;
          this.koediaCacheKey = null;
          this.selectedKoediaPackageKey = null;
        },
        deep: true,
      },
   },
   methods: {
    resolvedRoomPlans() {
      return this.selectMultipleRooms ? normalizeRoomPlans(this.roomPlans) : [];
    },
     naturalSort(a, b) {
       /**
        * Natural/alphanumeric sort for room names
        * Handles names like 'Chambre 2', 'Chambre 1', 'Chambre 10'
        * and sorts them as 1, 2, 3... instead of 1, 10, 2...
        */
       const nameA = a.name.toLowerCase();
       const nameB = b.name.toLowerCase();
       
       // Extract numbers from the room names
       const regex = /(\d+)/g;
       const numbersA = nameA.match(regex) || [];
       const numbersB = nameB.match(regex) || [];
       
       // If both have numbers, compare the first number
       if (numbersA.length > 0 && numbersB.length > 0) {
         const numA = parseInt(numbersA[0], 10);
         const numB = parseInt(numbersB[0], 10);
         if (numA !== numB) {
           return numA - numB;
         }
       }
       
       // Fall back to standard string comparison
       return nameA.localeCompare(nameB);
     },
     sortByPrice(a, b) {
       /**
        * Sort rooms by their lowest price in ascending order
        * Handles both Koedia and non-Koedia accommodations
        */
       const priceA = this.getRoomLowestPrice(a) || Infinity;
       const priceB = this.getRoomLowestPrice(b) || Infinity;
       
       // Convert to numbers for comparison
       const numPriceA = typeof priceA === 'string' ? parseFloat(priceA) : priceA;
       const numPriceB = typeof priceB === 'string' ? parseFloat(priceB) : priceB;
       
       return numPriceA - numPriceB;
     },
    toggleShowAllRooms() {
      const previouslyDisplayed = this.displayedRooms.map(r => r.id);
      
      this.showAllRooms = !this.showAllRooms;
      
      // Re-initialize swipers for newly displayed rooms after DOM update
      this.$nextTick(() => {
        // Get the newly displayed rooms
        const newlyDisplayed = this.displayedRooms.map(r => r.id);
        
        // Destroy swipers for rooms that are no longer displayed
        this.rooms.forEach(room => {
          if (previouslyDisplayed.includes(room.id) && !newlyDisplayed.includes(room.id)) {
            if (this.swiperInstances[room.id]) {
              this.swiperInstances[room.id].destroy(true, true);
              delete this.swiperInstances[room.id];
            }
          }
        });
        
        // Initialize swipers for newly displayed rooms
        this.initializeRoomSwipers();
      });
    },
    displayUserInfo(...args) {
      const eventName = resolveReservationEventName(this.accommodation_code);
      this.$emit(eventName, ...args);
    },
    getKoediaBoardLabel(option) {
      const board = option?.board;
      if (board && typeof board === 'object') {
        return Object.values(board)[0] || '';
      }
      return '';
    },
    getKoediaPackagesForRoom(room) {
      if (!room) return [];
      return this.koediaPossibilityPackages.filter((pkg) => pkg.roomIds.includes(room.id));
    },
    resolveRoomForKoediaOption(option) {
      const processedRoomId = String(option?.processed_room_id ?? option?.koedia_room_id ?? option?.room_id ?? '').trim().toLowerCase();
      const roomName = String(option?.room_name || '').trim().toLowerCase();

      return this.rooms.find((room) => {
        const roomKoediaId = String(room?.koedia_room_id || '').trim().toLowerCase();
        const roomKoediaName = String(room?.koedia_room_name || room?.name || '').trim().toLowerCase();
        return (processedRoomId && roomKoediaId && processedRoomId === roomKoediaId) || (roomName && roomKoediaName === roomName);
      }) || null;
    },
    selectKoediaPackage(pkg) {
      this.selectedKoediaPackageKey = pkg.key;
      this.reserveErrorMessage = '';

      const nextCartItems = {};
      pkg.options.forEach(({ room, option }) => {
        const tariffKey = `${room.id}_${option.tariff}_${option.room_id}`;
        nextCartItems[tariffKey] = {
          room,
          tariff: option.tariff,
          qty: 1,
          priceData: {
            totalPrice: Number(option?.room_price?.total?.rack) || 0,
            pricePerNight: Number(option?.room_price?.per_day?.rack) || 0,
            cancellationConditions: option?.refundable ? 'Annulation selon tarif' : 'Non remboursable',
            boardType: this.getKoediaBoardLabel(option),
            htValueTotal: 0,
            tvalTotal: 0,
            taxTotal: 0,
            selectedPriceOptionFee: option?.tariff_cancel_feed || null,
            houseHold: 0,
            koediaRoomAvailability: option,
            discountPercentage: 0,
            preparedRateDetails: null,
          }
        };
      });

      this.cartItems = nextCartItems;
      this.computeCartTotal();
    },
    openGuestModal() {
      this.$emit('open-guest-modal');
    },
    getRoomPhotos(room) {
      const fallbackImage = 'https://media.gettyimages.com/photos/bedroom-in-new-luxury-home-picture-id1194686012?k=6&m=1194686012&s=612x612&w=0&h=IX6Bjhwa5M5NtCtlKll-FFi_hn5lxrPwiUImH3fsZZ0=';
      
      // Check if photos_keys exists and is an array with items
      if (room?.photos_keys && Array.isArray(room.photos_keys) && room.photos_keys.length > 0) {
        // Take up to 5 photos from photos_keys
        const photos = room.photos_keys.map(photo => {
          const photoURL = photo;
          if (photoURL && photoURL.trim() && photoURL !== 'null' && photoURL !== 'undefined') {
            return photoURL.trim().replace(/['"]/g, ''); // Remove quotes that might break CSS
          }
          return fallbackImage;
        });
        
        // If we have valid photos, return them
        if (photos.length > 0) {
          return photos;
        }
      }
      
      // Fallback to photo_banner if available
      if (room?.photo_banner?.trim() && room.photo_banner !== 'null' && room.photo_banner !== 'undefined') {
        return [room.photo_banner.trim().replace(/['"]/g, '')]; // Remove quotes that might break CSS
      }
      
      // Final fallback to default image
      return [fallbackImage];
    },
    destroyAllSwipers() {
      // Destroy all swiper instances
      Object.values(this.swiperInstances).forEach(swiper => {
        if (swiper && swiper.destroy) {
          swiper.destroy(true, true);
        }
      });
      this.swiperInstances = {};
    },
    initializeRoomSwipers() {
      this.displayedRooms.forEach(room => {
        const sliderId = `.room-slider-${room.id}`;
        const sliderElement = document.querySelector(sliderId);
        
        if (sliderElement && !this.swiperInstances[room.id]) {
          this.swiperInstances[room.id] = new Swiper(sliderId, {
            slidesPerView: 1,
            pagination: {
              el: `${sliderId} .swiper-pagination`,
              type: "bullets",
            },
            navigation: {
              nextEl: `${sliderId} .swiper-button-next`,
              prevEl: `${sliderId} .swiper-button-prev`,
            },
            loop: true,
            touchRatio: 1,
            touchAngle: 45,
            allowTouchMove: true,
            on: {
              slideChange: (swiper) => {
                this.loadAdjacentImages(swiper);
              },
              slideChangeTransitionEnd: (swiper) => {
                this.loadAdjacentImages(swiper);
              }
            }
          });
        }
      });
    },
    loadAdjacentImages(swiper) {
      // Preload images adjacent to current slide
      const currentIndex = swiper.activeIndex;
      const slides = swiper.slides;
      
      slides.forEach((slide, index) => {
        // Load current and adjacent slides (within 1 slide distance)
        if (Math.abs(index - currentIndex) <= 1) {
          const dataSrc = slide.getAttribute('data-src');
          if (dataSrc && !slide.style.backgroundImage) {
            // Set background image for lazy-loaded slides
            slide.style.backgroundImage = `url('${dataSrc}')`;
          }
        }
      });
    },
    openRoomModal(room) {
      this.selectedRoom = room;
      this.showRoomModal = true;
    },
    closeRoomModal() {
      this.showRoomModal = false;
      this.selectedRoom = null;
    },
    showModalRoomGalery() {
      this.showRoomModal = false;
      this.showRoomGalery = !this.showRoomGalery;
    },
    toggleRoomTariffs(roomId) {
      if (this.getRoomAvailabilityStatus(roomId) === 'unavailable') {
        return;
      }
      
      this.$set(this.showTariffs, roomId, !this.showTariffs[roomId]);
      
      // If showing tariffs and no availability data, fetch it
      if (this.showTariffs[roomId] && !this.roomAvailabilities[roomId]) {
        this.fetchRoomAvailability(roomId);
      }
    },
    getRoomAvailabilityStatus(roomId) {
      if (!this.from || !this.to) {
        return 'search';
      }
      
      if (this.isSearching) {
        return 'searching';
      }
      
      const availability = this.roomAvailabilities[roomId];
      if (availability === null) {
        return 'unavailable';
      }
      
      if (availability && availability.length > 0) {
        if (!this.accommodation_code) {
          const availableTariffs = this.tariffsNotKoedia(roomId);
          if (!availableTariffs || availableTariffs.length === 0) {
            return 'unavailable';
          }
        }
        return 'available';
      }
      
      return 'search';
    },
    showVoirLesTarifsForDatePicker() {
      return !this.from || !this.to;
    },
    getRoomButtonText(roomId) {
      const status = this.getRoomAvailabilityStatus(roomId);
      
      switch (status) {
        case 'searching':
          return 'RECHERCHE EN COURS...';
        case 'unavailable':
          return 'INDISPONIBLE';
        case 'search':
          return 'INDISPONIBLE';
        case 'available':
          return 'VOIR LES TARIFS';
        default:
          return 'INDISPONIBLE';
      }
    },
    async fetchRoomAvailability(roomId) {
      if (!this.from || !this.to) {
        return;
      }
      
      this.isSearching = true;
      
      try {
        if (!this.accommodation_code) {
          // Non-Koedia availability
          const response = await fetcher.post('/rooms/' + roomId + '/availabilities');
          
          let filtered_data = response.data.filter((item) =>
            item.tariff &&
            item.tariff_price &&
            item.date &&
            new Date(item.date) >= new Date(this.from) &&
            new Date(item.date) <= new Date(this.to)
          );
          
          if (this.nights > 0) {
            const originalData = {...filtered_data}
            filtered_data = filtered_data.filter(item =>
              item.minimum_nights_stay ? (this.nights >= item.minimum_nights_stay) : true
            );
            // Check if there are multiple tariffs for the same date
            const hasMultipleTariffs = this.hasMultipleTariffsForSameDate(filtered_data);
            // Filter by tariff night requirement (n2, n3, n4, etc.) only if multiple tariffs exist
            filtered_data = filtered_data.filter(item => this.matchesTariffNightRequirement(item, hasMultipleTariffs));
            const uniqueDates = [...new Set(filtered_data.map(item => item.date))];

            if ((uniqueDates.length - 1) !== this.nights) {
              filtered_data = [];
            }

            if (filtered_data.length === 0 && originalData[0]?.minimum_nights_stay > 0) {
              this.minNightsNew[roomId] = originalData[0].minimum_nights_stay;
            }
          }

          if (filtered_data.length > 0) {
            this.minNightsNew[roomId] = filtered_data[0].minimum_nights_stay || this.minNightsNew[roomId];
          }

          this.$set(this.availabilitiesNotKoedia, roomId, filtered_data.filter((item) => item.tariff_price !== null));
          this.$set(this.roomAvailabilities, roomId, filtered_data.length > 0 ? filtered_data : null);
        } else {
          // Koedia availability - implementing from NewReservation.vue with caching
          const agesKey = (this.childAges || []).join('-');
          const roomPlansKey = JSON.stringify(this.resolvedRoomPlans());
          const roomCountKey = this.resolvedRoomPlans().length || 1;
          const cacheKey = `${this.koediaFrom}-${this.koediaTo}-${this.adults}-${this.childs}-${agesKey}-${roomCountKey}-${roomPlansKey}`;
          
          // Check if we already have cached data for these dates
          if (!this.koediaAvailabilityCache || this.koediaCacheKey !== cacheKey) {
            // If already loading, wait for it to complete
            if (this.koediaLoading) {
              // Wait for the loading to complete by polling
              while (this.koediaLoading) {
                await new Promise(resolve => setTimeout(resolve, 100));
              }
              // Use the cached data that should now be available
              this.availabilities = this.koediaAvailabilityCache;
            } else {
              // Set loading flag to prevent concurrent calls
              this.koediaLoading = true;
              
              try {
                this.ReqInventoryBook();
                const response = await this.getAvailability();

                this.koediaSessionId = response.data.koedia_session_id;
                this.availabilities = {};
                
                for (const roomData of response.data.availabilities) {
                  this.availabilities[roomData.room_name] = roomData;
                }
                
                // Cache the results
                this.koediaAvailabilityCache = this.availabilities;
                this.koediaCacheKey = cacheKey;
                if (this.showKoediaPackagePicker && this.selectedKoediaPackageKey) {
                  const stillAvailable = this.koediaPossibilityPackages.some((pkg) => pkg.key === this.selectedKoediaPackageKey);
                  if (!stillAvailable) {
                    this.clearCart();
                    this.selectedKoediaPackageKey = null;
                  }
                }
              } finally {
                // Always clear the loading flag
                this.koediaLoading = false;
              }
            }
          } else {
            // Use cached data
            this.availabilities = this.koediaAvailabilityCache;
          }
          
          // Find the specific room's availability by Koedia room id first, then name fallback
          const room = this.rooms.find(r => r.id === roomId);
          if (room) {
            const roomAvailability = this.roomAvailabilityForRoom(room);
            this.$set(this.roomAvailabilities, roomId, roomAvailability ? [roomAvailability] : null);
          } else {
            this.$set(this.roomAvailabilities, roomId, null);
          }
        }
        this.searched = true;
        this.emitRoomAvailabilityStatus();
      } catch (error) {
        console.error('Error fetching availabilities for room:', roomId, error);
        this.$set(this.roomAvailabilities, roomId, null);
        this.emitRoomAvailabilityStatus();
      } finally {
        this.isSearching = false;
      }
    },
    emitRoomAvailabilityStatus() {
      // Check if any room has available options
      const hasAvailableRooms = Object.values(this.roomAvailabilities)?.filter(v => v !== null)?.length > 0;
      this.$emit('room-availability-updated', hasAvailableRooms);
    },
    roomAvailability(roomName, availabilitySource = this.availabilities) {
      let lowerRoomName = '';
      if(roomName){
        lowerRoomName = roomName.toLowerCase().trim();
      }

      if (availabilitySource) {
        const lowerAvailabilities = Object.keys(availabilitySource).reduce((acc, key) => {
          acc[key.toLowerCase().trim()] = availabilitySource[key];
          return acc;
        }, {});

        return lowerAvailabilities[lowerRoomName];
      }
    },
    roomAvailabilityForRoom(room, availabilitySource = this.availabilities) {
      if (!room) {
        return null;
      }

      const roomKoediaRoomId = room.koedia_room_id ? String(room.koedia_room_id).trim() : '';
      if (roomKoediaRoomId && availabilitySource) {
        const matchedById = Object.values(availabilitySource).find((availability) =>
          Array.isArray(availability?.options) &&
          availability.options.some((option) => {
            const optionRoomId = String(option?.processed_room_id ?? option?.koedia_room_id ?? option?.room_id ?? '').trim();
            return optionRoomId === roomKoediaRoomId;
          })
        );

        if (matchedById) {
          return matchedById;
        }
      }

      return this.roomAvailability(room.koedia_room_name || room.name || '', availabilitySource);
    },
    roomAvailabilityNotKoedia(idx){
      if(this.availabilitiesNotKoedia){
        return this.availabilitiesNotKoedia[idx];
      }
    },
    getSelectedGuestCount() {
      const adults = Number.parseInt(this.adults, 10);
      const safeAdults = Number.isFinite(adults) && adults > 0 ? adults : 2;
      const childCountFromState = Number.parseInt(this.childs, 10);
      const safeChildren = Number.isFinite(childCountFromState) && childCountFromState >= 0
        ? childCountFromState
        : Array.isArray(this.childAges) ? this.childAges.filter((age) => age !== null && age !== undefined && age !== '').length : 0;

      return safeAdults + safeChildren;
    },
    tariffsNotKoedia(idx) {
      if (!this.availabilitiesNotKoedia[idx]) return [];

      const data = this.availabilitiesNotKoedia[idx];

      // Step 1: Build map => { tariff: Set(dates) }
      const tariffDateMap = {};

      data.forEach(item => {
        if (item.tariff && item.tariff !== "") {
          if (!tariffDateMap[item.tariff]) {
            tariffDateMap[item.tariff] = new Set();
          }
          tariffDateMap[item.tariff].add(item.date);
        }
      });

      // Step 2: Keep tariffs available for all nights
      const expectedDayCount = this.nights;

      const validTariffs = Object.keys(tariffDateMap).filter(tariff => {
        return tariffDateMap[tariff].size === expectedDayCount + 1;
      });

      // Step 3: Filter by guest count (tN tokens in tariff string)
      const guestCount = this.getSelectedGuestCount();

      return validTariffs.filter(tariff => {
        const tokens = String(tariff).split(',').map(t => t.trim());
        const guestToken = tokens.find(t => /^t\d+$/i.test(t));
        if (!guestToken) return true; // no guest constraint — always valid
        const required = parseInt(guestToken.replace(/^t/i, ''), 10);
        return Number.isFinite(required) ? guestCount === required : true;
      });
    },
    formatDate(date) {
      if(date){
        if (date.includes('-')) {
          return date;
        }
        const dateBits = date.split('/');
        return `${dateBits[2]}-${dateBits[1]}-${dateBits[0]}`;
      } else {
        return null;
      }
    },
    formatDateKoedia(date) {
      if (!date) return null;
      if (typeof date === 'object' && date instanceof Date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      }
      if (typeof date === 'string' && date.includes('-')) return date;
      if (typeof date === 'string') {
        const dateBits = date.split('/');
        return dateBits.length === 3 ? `${dateBits[2]}-${dateBits[1]}-${dateBits[0]}` : date;
      }
      return null;
    },
     extractNightRequirement(tariff) {
       if (!tariff) return null;
       const nightMatch = tariff.match(/n(\d+)/);
       return nightMatch ? parseInt(nightMatch[1], 10) : null;
     },
     hasMultipleTariffsForSameDate(filteredData) {
       // Group items by date and count unique tariffs per date
       const tariffsByDate = {};
       filteredData.forEach(item => {
         if (!tariffsByDate[item.date]) {
           tariffsByDate[item.date] = new Set();
         }
         if (item.tariff) {
           tariffsByDate[item.date].add(item.tariff);
         }
       });
       
       // Check if any date has multiple different tariffs
       return Object.values(tariffsByDate).some(tariffSet => tariffSet.size > 1);
     },
     matchesTariffNightRequirement(item, hasMultipleTariffs) {
       const requiredNights = this.extractNightRequirement(item.tariff);
       if (requiredNights === null) {
         return true;
       }
       // Only do exact night comparison if there are multiple tariffs for same date
       if (!hasMultipleTariffs) {
         return true;
       }
       return this.nights === requiredNights;
     },
    resetAvailability() {
      this.koediaFrom = null;
      this.koediaTo = null;
      this.from = null;
      this.to = null;
      this.nights = null;
      this.childs = 0;
      this.childAges = [];
      this.previousSearchKey = null;
      this.roomAvailabilities = {};
      this.availabilitiesNotKoedia = {};
      this.showTariffs = {};
      this.searched = false;
      this.koediaAvailabilityCache = null;
      this.koediaCacheKey = null;
      this.clearCart();
    },
    loadState() {
      if (this.entireLodging) {
        return;
      }
      const state = JSON.parse(localStorage.getItem('reservationState'));
      if (state && state.koediaFrom && state.koediaTo) {
        const roomPlansKey = JSON.stringify(normalizeRoomPlans(state.room_plans));
        const nextSearchKey = [
          state.koediaFrom,
          state.koediaTo,
          state.adults || this.adults || 2,
          state.childs || 0,
          Array(state.children_ages || []).join('-'),
          roomPlansKey
        ].join('|');

        if (this.previousSearchKey && this.previousSearchKey !== nextSearchKey) {
          this.clearCart();
        }
        this.previousSearchKey = nextSearchKey;

        this.koediaFrom = state.koediaFrom;
        this.koediaTo = state.koediaTo;
        this.from = state.from;
        this.to = state.to;
        this.childs = state.childs || 0;
        this.childAges = Array.isArray(state.children_ages) ? [...state.children_ages] : [];

        // Calculate nights
        if (this.from && this.to) {
          const fromDate = new Date(this.from);
          const toDate = new Date(this.to);
          this.nights = Math.ceil((toDate - fromDate) / (1000 * 60 * 60 * 24));
        }
        
        // Fetch inventories for Koedia accommodations
        if (this.accommodation_code) {
          this.fetchInventories();
        }
        
        // Auto-fetch availabilities for all rooms
        this.rooms.forEach(room => {
          this.fetchRoomAvailability(room.id);
        });
        
        // Emit availability status after fetching
        this.$nextTick(() => {
          this.emitRoomAvailabilityStatus();
        });
      }
      this.$emit('searchComplete');
    },
    async ReqInventoryBook() {
      try {
        const res = await fetcher.post(
          `/lodgings/${this.lodging.slug}/request_inventory_booking`,
          {
            start: this.koediaFrom,
            end: this.koediaTo,
          }
        );
        if(res.data){
           this.minNights = res.data.booking_request;
        }
      } catch (e) {
        this.isSearching = false;
        console.error(e);
      }
    },
    getAvailability(options = {}) {
      const configuredRoomPlans = normalizeRoomPlans(options?.roomPlans);
      const roomPlans = configuredRoomPlans.length > 0 ? configuredRoomPlans : this.resolvedRoomPlans();
      const roomCount = Number(options?.roomCount) > 0
        ? Number(options.roomCount)
        : (roomPlans.length > 0 ? roomPlans.length : 1);
      return fetcher.post(`/lodgings/${this.lodging.slug}/get_availability`, {
        accommodation_code: this.accommodation_code,
        start: this.formatDate(this.koediaFrom),
        end: this.formatDate(this.koediaTo),
        adults: this.adults || this.adults !== 0 ? this.adults : 2,
        children: this.childs,
        children_ages: this.childAges,
        room_count: roomCount,
        room_plans: roomPlans,
        ospita_tracking_id: ensureOspitaTrackingId(),
      });
    },
     async fetchInventories() {
       if (!this.accommodation_code || !this.koediaFrom || !this.koediaTo) {
         return;
       }

       const cacheKey = `${this.koediaFrom}-${this.koediaTo}`;

       // Return cached data if available
       if (this.roomInventories && this.inventoriesCacheKey === cacheKey && Object.keys(this.roomInventories).length > 0) {
         return;
       }

       this.inventoriesLoading = true;

       try {
         const response = await fetcher.post(
           `/lodgings/${this.lodging.slug}/get_inventories`,
           {
             start: this.koediaFrom,
             end: this.koediaTo,
           }
         );

          if (response.data && response.data.inventories) {
            this.roomInventories = response.data.inventories;
            this.inventoriesCacheKey = cacheKey;

            // Set minNightsNew from inventory data for each room
            this.rooms.forEach(room => {
              const inventory = this.getInventoryForRoom(room.id);
              if (inventory && inventory.min_night_count && inventory.min_night_count > 1) {
                this.$set(this.minNightsNew, room.id, inventory.min_night_count);
              }
            });
          }
       } catch (error) {
         console.error('Error fetching inventories:', error);
       } finally {
         this.inventoriesLoading = false;
       }
     },
      getInventoryForRoom(roomId) {
        if (!this.roomInventories) {
          return null;
        }

        // Find the room by ID to compare Koedia code first, then name fallback.
        const room = this.rooms.find(r => r.id === roomId);
        if (!room) {
          return null;
        }

        const normalizedRoomId = room.koedia_room_id ? String(room.koedia_room_id).toLowerCase().trim() : '';
        const normalizedRoomName = (room.koedia_room_name || room.name || '').toLowerCase().trim();

        if (normalizedRoomId) {
          for (const key in this.roomInventories) {
            if (String(key).toLowerCase().trim() === normalizedRoomId) {
              return this.roomInventories[key];
            }
          }
        }

        // Search through inventories to find a match by the 'name' property
        for (const key in this.roomInventories) {
          const inventory = this.roomInventories[key];
          if (inventory && inventory.name) {
            const normalizedInventoryName = inventory.name.toLowerCase().trim();
            // Exact match with case-insensitive comparison
            if (normalizedInventoryName === normalizedRoomName) {
              return inventory;
            }
          }
        }

        return null;
      },
      getRoomLowestPrice(room) {
        // For Koedia accommodations, get from inventory
        if (this.accommodation_code) {
          const inventory = this.getInventoryForRoom(room.id);
          if (inventory && inventory.lowest_price) {
            return inventory.lowest_price;
          }
        }
        // Fallback to room's lowest_price
        return room.lowest_price;
      },
      incrementTariff(roomId, data) {
        const {
          tariff,
          totalPrice,
          pricePerNight,
          cancellationConditions,
          boardType,
          htValueTotal,
          tvalTotal,
          taxTotal,
          selectedPriceOptionFee,
          houseHold,
          koediaRoomAvailability,
          discountPercentage,
          preparedRateDetails,
        } = data;

        const room = this.rooms.find(r => r.id === roomId);
        const key = `${roomId}_${tariff}`;
        const maxQty = this.getRoomMaxQty(room);

        const buildPriceData = (existing = {}) => ({
          totalPrice: parseFloat(totalPrice) || 0,
          pricePerNight: pricePerNight !== undefined ? pricePerNight : (existing.pricePerNight || null),
          cancellationConditions: cancellationConditions !== undefined ? cancellationConditions : (existing.cancellationConditions || ''),
          boardType: boardType !== undefined ? boardType : (existing.boardType || ''),
          htValueTotal: htValueTotal !== undefined ? (parseFloat(htValueTotal) || 0) : (parseFloat(existing.htValueTotal) || 0),
          tvalTotal: tvalTotal !== undefined ? (parseFloat(tvalTotal) || 0) : (parseFloat(existing.tvalTotal) || 0),
          taxTotal: taxTotal !== undefined ? (parseFloat(taxTotal) || 0) : (parseFloat(existing.taxTotal) || 0),
          selectedPriceOptionFee: selectedPriceOptionFee !== undefined ? (selectedPriceOptionFee || null) : (existing.selectedPriceOptionFee || null),
          houseHold: houseHold !== undefined ? (parseFloat(houseHold) || 0) : (parseFloat(existing.houseHold) || 0),
          koediaRoomAvailability: koediaRoomAvailability !== undefined ? (koediaRoomAvailability || null) : (existing.koediaRoomAvailability || null),
          discountPercentage: discountPercentage !== undefined
            ? (parseFloat(discountPercentage) || 0)
            : (parseFloat(existing.discountPercentage) || 0),
          preparedRateDetails: preparedRateDetails !== undefined
            ? (preparedRateDetails || null)
            : (existing.preparedRateDetails || null),
        });

        
        if (!this.selectMultipleRooms) {
          this.cartItems = {};
          this.$set(this.cartItems, key, {
            room,
            tariff,
            qty: 1,
            priceData: buildPriceData(),
          });
          this.computeCartTotal();
          this.reserveAll();
          return;
        }

        if (!this.cartItems[key]) {
          this.$set(this.cartItems, key, {
            room,
            tariff,
            qty: 0,
            priceData: buildPriceData(),
          });
        }

        if (this.cartItems[key].qty < maxQty) {
          this.$set(this.cartItems[key], 'qty', this.cartItems[key].qty + 1);
          this.$set(this.cartItems[key], 'priceData', buildPriceData(this.cartItems[key].priceData));
          this.computeCartTotal();
        }
      },
      decrementTariff(roomId, tariff) {
        const key = `${roomId}_${tariff}`;
        if (this.cartItems[key] && this.cartItems[key].qty > 0) {
          this.$set(this.cartItems[key], 'qty', this.cartItems[key].qty - 1);
          this.computeCartTotal();
        }
      },
      getTariffCount(roomId, tariff) {
        const key = `${roomId}_${tariff}`;
        return this.cartItems[key]?.qty || 0;
      },
      /**
       * Returns a map of { tariffKey: qty } for a given room,
       * so ReservationCard can display the correct qty per tariff via the tariffQtys prop.
       */
      getRoomTariffQtys(roomId) {
        const result = {};
        Object.entries(this.cartItems).forEach(([key, item]) => {
          if (item.room && item.room.id === roomId) {
            result[item.tariff] = item.qty;
          }
        });
        return result;
      },
      /**
       * Returns the max bookable quantity for a room.
       * For Koedia: uses stock_left from inventory.
       * For non-Koedia: uses max_rooms_bookable from the room object.
       */
      getRoomMaxQty(room) {
        if (!room) return 1;
        if (this.accommodation_code) {
          return 1;
        }
        return room.max_rooms_bookable || 1;
      },
      computeCartTotal() {
        let totalAmount = 0;
        Object.values(this.cartItems).forEach(item => {
          if (item.qty > 0 && item.priceData && item.priceData.totalPrice) {
            // totalPrice is the full stay total (already discount-adjusted) for 1 room
            totalAmount += parseFloat(item.priceData.totalPrice) * item.qty;
          }
        });
        this.cartTotal = totalAmount;
      },
      clearCart() {
        this.cartItems = {};
        this.cartTotal = 0;
        this.reserveErrorMessage = '';
      },
      buildSelectedTariffsFromCart() {
        const selectedTariffs = [];
        Object.values(this.cartItems).forEach((item) => {
          if (item.qty > 0) {
            const selectedKoediaOption = item.priceData?.koediaRoomAvailability || null;
            selectedTariffs.push({
              roomId: item.room?.id,
              roomName: item.room?.name || 'Chambre',
              koediaRoomName: item.room?.koedia_room_name || item.room?.name || '',
              tariff: item.tariff,
              qty: item.qty,
              selectedKoediaOption,
              priceData: {
                totalPrice: item.priceData.totalPrice,
                pricePerNight: item.priceData.pricePerNight,
                cancellationConditions: item.priceData.cancellationConditions,
                boardType: item.priceData.boardType,
                htValueTotal: item.priceData.htValueTotal,
                tvalTotal: item.priceData.tvalTotal,
                taxTotal: item.priceData.taxTotal,
                selectedPriceOptionFee: item.priceData.selectedPriceOptionFee,
                houseHold: item.priceData.houseHold,
                koediaRoomAvailability: selectedKoediaOption,
                discountPercentage: item.priceData.discountPercentage,
                preparedRateDetails: item.priceData.preparedRateDetails || null,
              }
            });
          }
        });
        return selectedTariffs;
      },
      buildRoomPlansFromSelectedTariffs(selectedTariffs) {
        const configuredPlans = this.resolvedRoomPlans();
        if (configuredPlans.length > 0) {
          return configuredPlans;
        }

        return selectedTariffs.map(() => ({
          room_count: 1,
          adults: this.adults || this.adults !== 0 ? this.adults : 2,
          children: this.childs || 0,
          children_ages: this.childAges,
        }));
      },
      findMatchingKoediaOptions(options, selectedKoediaOption, tariffIndex) {
        if (!Array.isArray(options) || options.length === 0) return [];

        const selectedKoediaRoomId = selectedKoediaOption?.room_id ? String(selectedKoediaOption.room_id).trim() : null;

        if (selectedKoediaRoomId) {
          const exactRoomIdMatches = options.filter((option) => {
            const optionRoomId = String(option?.room_id ?? '').trim();
            return optionRoomId === selectedKoediaRoomId;
          });
          if (exactRoomIdMatches.length > 0) return exactRoomIdMatches;
        }

        if (selectedKoediaOption) {
          const metadataMatches = options.filter((option) => {
            if (!option) return false;

            const sameTariff = String(option?.tariff ?? '') === String(selectedKoediaOption?.tariff ?? '');
            const sameCancelFee = String(option?.tariff_cancel_feed ?? '') === String(selectedKoediaOption?.tariff_cancel_feed ?? '');
            const sameBoardType = String(option?.board_type ?? '') === String(selectedKoediaOption?.board_type ?? '');
            const sameRefundable = String(option?.refundable ?? '') === String(selectedKoediaOption?.refundable ?? '');

            return sameTariff && sameCancelFee && sameBoardType && sameRefundable;
          });
          if (metadataMatches.length > 0) return metadataMatches;
        }

        const optionIndex = Number(tariffIndex);
        const selectedOptionByIndex = Number.isInteger(optionIndex) ? options[optionIndex] : null;
        if (selectedOptionByIndex) {
          const tariffMatches = options.filter((option) => String(option?.tariff ?? '') === String(selectedOptionByIndex?.tariff ?? ''));
          if (tariffMatches.length > 0) return tariffMatches;
          return [selectedOptionByIndex];
        }

        return options;
      },
      resolveCommonKoediaPossibility(selectedTariffs, validationAvailabilities) {
        const candidateSets = selectedTariffs.map((item) => {
          const room = this.rooms.find((r) => r.id === item.roomId);
          const roomAvailability = room ? this.roomAvailabilityForRoom(room, validationAvailabilities) : null;
          const options = Array.isArray(roomAvailability?.options) ? roomAvailability.options : [];
          const qty = Number(item?.qty) > 0 ? Number(item.qty) : 1;
          const matchedOptions = this.findMatchingKoediaOptions(options, item.selectedKoediaOption || null, item.tariff);

          const possibilities = matchedOptions.reduce((acc, option) => {
            const possibilityKey = option?.possibility_key;
            if (!possibilityKey) return acc;

            const nextOptions = acc[possibilityKey] || [];
            nextOptions.push(option);
            acc[possibilityKey] = nextOptions;
            return acc;
          }, {});

          return {
            item,
            room,
            qty,
            matchedOptions,
            possibilities,
          };
        });

        if (candidateSets.some((entry) => entry.matchedOptions.length === 0)) {
          return null;
        }

        const commonPossibilityKeys = candidateSets.reduce((keys, entry, index) => {
          const entryKeys = Object.keys(entry.possibilities).filter((key) => entry.possibilities[key].length >= entry.qty);
          if (index === 0) return entryKeys;
          return keys.filter((key) => entryKeys.includes(key));
        }, []);

        if (commonPossibilityKeys.length === 0) {
          return null;
        }

        const selectedPossibilityKey = commonPossibilityKeys[0];
        return {
          possibilityKey: selectedPossibilityKey,
          entries: candidateSets.map((entry) => ({
            ...entry,
            matchedOptions: entry.possibilities[selectedPossibilityKey] || [],
          })),
        };
      },
      async reserveAll() {
        this.reserveErrorMessage = '';

        let selectedTariffs = this.buildSelectedTariffsFromCart();
        if (selectedTariffs.length === 0) return;

        const roomCount = selectedTariffs.reduce((sum, item) => sum + (Number(item?.qty) || 1), 0);

        if (this.accommodation_code && this.selectMultipleRooms) {
          this.isReserveValidating = true;
          try {
            const roomPlans = this.buildRoomPlansFromSelectedTariffs(selectedTariffs);
            if (roomPlans.length !== roomCount) {
              this.reserveErrorMessage = 'Le nombre de chambres sélectionnées doit correspondre à votre configuration voyageurs.';
              return;
            }
            let roomPlanCursor = 0;
            const response = await this.getAvailability({ roomCount, roomPlans });
            this.koediaSessionId = response?.data?.koedia_session_id || this.koediaSessionId;

            const freshAvailabilities = Array.isArray(response?.data?.availabilities) ? response.data.availabilities : [];
            const validationAvailabilities = {};
            for (const roomData of freshAvailabilities) {
              if (roomData?.room_name) validationAvailabilities[roomData.room_name] = roomData;
            }

            const resolvedPossibility = this.resolveCommonKoediaPossibility(selectedTariffs, validationAvailabilities);
            if (!resolvedPossibility) {
              this.reserveErrorMessage = 'Les chambres selectionnees ne correspondent pas a une meme disponibilite de reservation. Veuillez choisir une combinaison proposee ensemble.';
              return;
            }

            const selectedRooms = [];
            selectedTariffs = resolvedPossibility.entries.map(({ item, room, qty, matchedOptions }) => {
              const uniqueRoomIds = [...new Set(
                matchedOptions
                  .map((option) => (option?.room_id ? String(option.room_id) : null))
                  .filter(Boolean)
              )];
              const assignedRoomIds = uniqueRoomIds.slice(0, qty);
              const roomId = assignedRoomIds[0] || null;
              const assignedRoomPlans = roomPlans.slice(roomPlanCursor, roomPlanCursor + qty);
              roomPlanCursor += qty;
              const selectedKoediaOption = matchedOptions[0] || item.selectedKoediaOption || null;

              if (roomId) {
                selectedRooms.push({
                  room_id: roomId,
                  room_ids: assignedRoomIds,
                  room_name: room?.koedia_room_name || item.roomName || '',
                  qty,
                  tariff: item.tariff,
                  possibility_key: resolvedPossibility.possibilityKey,
                  room_plans: assignedRoomPlans,
                });
              }

              return {
                ...item,
                koediaRoomId: roomId,
                koediaRoomIds: assignedRoomIds,
                selectedKoediaOption,
                roomPlans: assignedRoomPlans,
              };
            });

            const unavailable = selectedTariffs.some((item) => !item.koediaRoomId || item.koediaRoomIds.length < (Number(item?.qty) > 0 ? Number(item.qty) : 1));
            if (unavailable) {
              this.reserveErrorMessage = 'Aucune chambre disponible pour les critères sélectionnés.';
              return;
            }

            this.$emit('reserve-multiple', {
              selectedTariffs: selectedTariffs,
              cartTotal: this.cartTotal,
              accommodation_code: this.accommodation_code,
              koediaSessionId: this.koediaSessionId,
              room_count: roomCount,
              selected_rooms: selectedRooms,
              room_plans: roomPlans,
            });
            return;
          } catch (error) {
            console.error('Error validating multi-room Koedia availability:', error);
            this.reserveErrorMessage = 'Aucune chambre disponible pour les critères sélectionnés.';
            return;
          } finally {
            this.isReserveValidating = false;
          }
        }

        this.$emit('reserve-multiple', {
          selectedTariffs: selectedTariffs,
          cartTotal: this.cartTotal,
          accommodation_code: this.accommodation_code,
          koediaSessionId: this.koediaSessionId,
          room_count: roomCount,
          selected_rooms: [],
          room_plans: [],
        });
      }
   },
  mounted() {
    this.$nextTick(() => {
      this.initializeRoomSwipers();
      this.loadState();
    });
  },
  beforeDestroy() {
    // Clean up swiper instances
    Object.values(this.swiperInstances).forEach(swiper => {
      if (swiper && swiper.destroy) {
        swiper.destroy(true, true);
      }
    });
    this.swiperInstances = {};
  }
};
</script>

<style scoped lang="scss">
.lodging-rooms-show {
  .koedia-room-combinations {
    background: linear-gradient(135deg, #f8f5ef 0%, #eef5f1 100%);
    border: 1px solid #d9e7df;
    border-radius: 14px;
    padding: 18px;
  }

  .koedia-package-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 14px;

    @media (max-width: 768px) {
      grid-template-columns: 1fr;
    }
  }

  .koedia-package-card {
    width: 100%;
    background: #ffffff;
    border: 1px solid #d9e7df;
    border-radius: 12px;
    padding: 16px;
    transition: all 0.2s ease;
    color: #111111;

    &:hover {
      border-color: #2C5E4B;
      box-shadow: 0 8px 24px rgba(44, 94, 75, 0.12);
    }

    &.selected {
      border-color: #2C5E4B;
      box-shadow: 0 8px 24px rgba(44, 94, 75, 0.16);
      background: #f7fbf9;
    }
  }

  .koedia-package-rooms {
    border-top: 1px solid #e7ece9;
    border-bottom: 1px solid #e7ece9;
  }

  .koedia-package-room-line {
    padding: 10px 0;

    & + .koedia-package-room-line {
      border-top: 1px solid #e7ece9;
    }
  }

  .current-room-label {
    display: inline-block;
    margin-left: 6px;
    border-radius: 999px;
    background: #2C5E4B;
    color: #ffffff;
    padding: 2px 7px;
    font-size: 10px;
    text-transform: uppercase;
    vertical-align: 1px;
  }

  .koedia-package-meta {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;

    span {
      border-radius: 999px;
      background: #eef5f1;
      color: #2C5E4B;
      padding: 6px 10px;
      font-size: 12px;
      font-weight: 600;
    }
  }

  .lodging-room-photo {
    height: 170px;
    border-radius: 10px;

    @media (max-width: 768px) {
      height: 203px;
    }

    .room-image-container {
      width: 100%;
      height: 170px;
      border-radius: 10px;
      overflow: hidden;
      position: relative;
      @media (max-width: 768px) {
        height: 203px;
      }
    }

    .room-image-slider {
      width: 100%;
      height: 100%;
      border-radius: 10px;
    }

    .swiper-wrapper {
      z-index: unset !important;
    }

    .swiper-slide {
      width: 100% !important;
      height: 170px;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      border-radius: 10px;

      @media (max-width: 768px) {
        height: 203px;
      }
    }
  }

  .lodging-room-info {
    display: flex;
    flex-direction: column;
    justify-content: center;

    .room-details {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 8px;
    }

    .room-details p {
      margin: 0;
      display: flex;
      align-items: center;
      position: relative;
    }

    .room-details p:not(:last-child)::after {
      content: "";
      display: inline-block;
      width: 4px;
      height: 4px;
      margin-left: 8px;
      background: #000000;
      border: 1px solid #000000;
      border-radius: 50%;
    }
  }
}

// Swiper navigation and pagination styles
.room-image-slider {
  .swiper-button-prev, .swiper-button-next {
    top: 60% !important;
    width: 20px !important;
    height: 20px !important;
    cursor: pointer;
    border-radius: 9999px;
    outline: 0;
    background: #00000053 0% 0% no-repeat padding-box;
    padding: 0.3rem;
    transition: all 0.3s ease;
    opacity: 1;
    z-index: unset !important;

    @media screen and (min-width: 769px) {
      &:hover {
        background-color: rgba(255, 255, 255, 1) !important;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
        transform: scale(1.05);

        &::after {
          color: black;
        }
      }
    }

    &:after {
      font-size: 10px;
      color: white;
    }
  }

  .swiper-pagination {
    bottom: 8px !important;
    z-index: unset !important;
    
    .swiper-pagination-bullet {
      background: rgba(255, 255, 255, 0.7);
      opacity: 1;
      
      &.swiper-pagination-bullet-active {
        background: white !important;
      }
    }
  }
}

.hortense-btn-disabled {
  background: #2C5E4B;
  opacity: 0.6;
  color: white;
  border: none;
  padding: 16px 36px;
  cursor: not-allowed;
  text-align: center;
  font-weight: bold;
  font-size: 13px;
}

.hortense-btn-primary {
  i {
    color: white;
  }
}

.hortense-btn-primary-active {
  background: #F5F5F59A 0% 0% no-repeat padding-box;
  border: 1px solid #2C5E4B;
  color: #2C5E4B;

  i {
    color: #2C5E4B;
  }
}

.stock-left-badge {
  color: #D56A70;
  font-weight: bold;
}

.sticky-reserve-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: white;
  border-top: 1px solid #e0e0e0;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1);
  z-index: 100;
  padding: 16px 20px;

  .bar-content {
    max-width: 1200px;
    margin: 0 auto;
    gap: 20px;
  }

  .bar-info {
    flex: 1;

    p {
      margin: 0;
    }

    .rooms-count {
      font-weight: bold;
      color: #2C5E4B;
      font-size: 20px;
    }
  }

  .hortense-btn-primary {
    white-space: nowrap;
    min-width: 150px;
  }
}

@media screen and (max-width: 768px) {
  .sticky-reserve-bar {
    margin-bottom: 8.5rem;
    padding: 12px 16px;

    .bar-content {
      gap: 12px;
    }

    .hortense-btn-primary {
      width: 100%;
    }
  }
}

@media screen and (max-width: 768px) {
   .lodging-room-item {
     .hortense-btn-primary {
       width: auto !important;
     }
   }

   .lodging-room-item {
     .hortense-btn-primary {
       height: 40px !important;
     }
   }
}
</style>
